const MOBILE_BREAK_POINT = 640;

const scrollToSection = (id) => {
  const element = document.getElementById(id);
  const position = element.offsetTop;
  const innerWidth = window.innerWidth;
  const gap = innerWidth >  MOBILE_BREAK_POINT ? 90 : 60;
  if (element) {
    setTimeout(() => {
      window.scrollTo({ top: position - gap, behavior: "smooth" });
    }, 100)
  }
};

export { scrollToSection };
